import 'mutationobserver-shim';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { createApp } from 'vue';
import 'vue-datepicker-next/locale/ru';
import axios from 'axios';

axios.defaults.withCredentials = true;
import vSelect from 'vue-select';
import { createBootstrap } from './plugins/bootstrap-vue';
import * as BootstrapVueNext from 'bootstrap-vue-next';
import { iconsPlugin } from './plugins/icons';
import App from '@/App.vue';
import ContextMenu from '@/components/ContextMenu.vue';
import InfiniteLoading from 'v3-infinite-loading/lib/v3-infinite-loading.umd.js';
import { pinia } from './lib/store';
import { router } from './router.js';

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(createBootstrap());
app.use(iconsPlugin);

Object.entries(BootstrapVueNext).forEach(([name, component]) => {
  if (name.startsWith('B') && component !== null && typeof component === 'object') {
    app.component(name, component);
  }
});
app.component('b-btn', BootstrapVueNext.BButton);
app.component('ContextMenu', ContextMenu);
app.component('v-select', vSelect);
app.component('infinite-loading', InfiniteLoading);

app.mount('#app');
